import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

export default class HealthcareServiceFixedTimeDuration extends BackboneElement {
    static __className = 'HealthcareServiceFixedTimeDuration';

    __objectStructure = {
        perUnitDuration: Number,
        perUnitCharge: String,
        maxUnitsAllowed: Number,
    };

    constructor(constructJson, className = 'HealthcareServiceFixedTimeDuration') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
